import { ChangeDetectorRef, Component, HostListener, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgSelectComponent, NgMultiLabelTemplateDirective, NgOptgroupTemplateDirective, NgOptionTemplateDirective } from '@ng-select/ng-select';
import { CustomProductsService } from '../custom-products.service';
import { FilterSortModel } from '../../../../core/model/filter-sort.model';
import { FormArray, UntypedFormBuilder, UntypedFormGroup, FormsModule } from '@angular/forms';
import { FormControl } from '@angular/forms';
import { ViewEncapsulation } from '@angular/core';
import { NgClass, NgIf, NgFor } from '@angular/common';
import { I18nModule } from '@spartacus/core';
@Component({
    selector: 'app-custom-products-filter-bar',
    templateUrl: './custom-products-filter-bar.component.html',
    styleUrls: ['./custom-products-filter-bar.component.scss'],
    imports: [NgClass, NgSelectComponent, FormsModule, NgMultiLabelTemplateDirective, NgOptgroupTemplateDirective, NgOptionTemplateDirective, NgIf, NgFor, I18nModule]
})
export class CustomProductsFilterBarComponent implements OnInit, OnDestroy {
  @ViewChild(NgSelectComponent) ngSelectComponent: NgSelectComponent;
  @ViewChild('testselect') private myselect: NgSelectComponent;
  filterSortModel: FilterSortModel;
  selectedPort;
  selectedPortTest;
  selectedProductType;
  selectedProduct;
  ports = [];
  searchInput = '';
  sampleProduct = [];
  samplePort = [];
  sampleProductName = [];
  data: any;
  filterListSelected = [];
  selectedPortsList = [];
  productTypes = [];
  hidebutton = false;
  productsList = [];
  loggedinUser: any;
  customerId: any;
  pageSize = 5;
  currentPage = 1;
  sidebar: boolean;
  form: UntypedFormGroup = null;
  checkedform: UntypedFormGroup;
  length: number;
  checkArray: any;
  checkedportform: UntypedFormGroup;
  checkedproductform: UntypedFormGroup;
  checkedproductTypeform: UntypedFormGroup;
  portlength = 0;
  productlength = 0;
  isPortNull = true;
  isTypeNull = true;
  isProductNull = true;
  producttypelength = 0;
  showClear = false;
  mobileCurrentSelection = null;
  isDisabledCheckBox = false;
  constructor(private customProductService: CustomProductsService,
              private cd: ChangeDetectorRef, private fb: UntypedFormBuilder) {
    this.checkedportform = this.fb.group({
      checkArray: this.fb.array([])
    });
    this.checkedproductform = this.fb.group({
      checkArray: this.fb.array([])
    });
    this.checkedproductTypeform = this.fb.group({
      checkArray: this.fb.array([])
    });
  }

  ngOnInit(): any {
    this.sidebar = true;
    // this.productsFilterData();
    this.customProductService.languageChange$.subscribe(data => {
      if (data != null) {
        this.selectedPort = null;
        this.selectedProductType = null;
        this.selectedProduct = null;
        this.isPortNull = true;
        this.isTypeNull = true;
        this.isProductNull = true;
        this.customProductService.getFilterInput(null);
        this.currentPage = 0;
        this.pageSize = 2;
        this.customProductService.filterValue = null;
        this.getFacetsData(null);
       // this.productsFilterData();
      }
    });

  }


  searchQuote(searchWord): any {
    this.showClear = false;
    this.selectedPort = [];
    this.selectedProductType = [];
    this.selectedProduct = [];
    this.isPortNull = true;
    this.isTypeNull = true;
    this.isProductNull = true;
    this.productsFilterData();
    this.customProductService.filterValue = searchWord;
    this.customProductService.getSearchInput(searchWord);
    this.portlength = 0;
    this.productlength = 0;
    this.producttypelength = 0;
    this.length = 0;
  }


  getProductTypeAndproductByPort(query): any {
    this.customProductService.getBrowseByPortsData(0, 20 , 'relevance', query).subscribe(data => {
      this.data = data;
      this.cd.detectChanges();
      this.sampleProduct = [];
      this.samplePort = [];
      this.sampleProductName = [];
      this.selectedProductType = [];
      this.selectedProduct = [];
      this.selectedPort = [];
      this.productTypes = [];
      this.productsList = [];
      for (const item of this.data?.facets) {
        if (item.name === 'portName') {
          for (const values of item.values) {
           //const portUrl = values.query.url.split('=');
           if (values.selected){
             this.selectedPort.push(values.query.query.value);
           }
           this.samplePort.push({
              id: values.query.query.value,
              ports: 'Ports',
              name: values.name,
              selected: values.selected
            });
           this.ports = this.samplePort;
          }
        }
        if (item.name === 'productType') {
          for (const values of item.values) {
            this.sampleProduct.push({
              id: values.query.query.value,
              name: values.name,
              productType: 'Product Types',
              selected: values.selected
            });
            this.productTypes = this.sampleProduct;
          }
        }
        if (item.name === 'baseProductCode') {
          for (const values of item.values) {
            this.sampleProductName.push({
              id: values.query.query.value,
              product: 'Products',
              name: values.name,
              selected: values.selected
            });
            this.productsList = this.sampleProductName;
          }
        }
      }
    });
    this.cd.detectChanges();
    this.producttypelength = 0;
  }

  getProductItemByProductType(query): any {
    this.customProductService.getProducts(this.currentPage, this.pageSize, 'relevance', query).subscribe(data => {
      this.data = data;
      this.cd.detectChanges();
      this.sampleProductName = [];
      this.sampleProduct = [];
      this.samplePort = [];
      this.sampleProductName = [];
      for (const item of this.data.facets) {
        if (item.name === 'portName') {
          for (const values of item.values) {
           //const portUrl = values.query.url.split('=');
           this.samplePort.push({
              id: values.query.query.value,
              ports: 'Ports',
              name: values.name,
              selected: values.selected
            });
           this.ports = this.samplePort;
          }
        }
        if (item.name === 'productType') {
          for (const values of item.values) {
            this.sampleProduct.push({
              id: values.query.query.value,
              name: values.name,
              productType: 'Product Types',
              selected: values.selected
            });
            this.productTypes = this.sampleProduct;
          }
        }
        if (item.name === 'baseProductCode') {
          for (const values of item.values) {
            this.sampleProductName.push({
              id: values.query.query.value,
              product: 'Products',
              name: values.name,
              selected: values.selected
            });
            this.productsList = this.sampleProductName;
          }
        }
      }
    });
    this.productlength = 0;
  }
  productsFilterData(): any {
    this.customProductService.getProducts(this.currentPage, this.pageSize).subscribe(data => {
      this.data = data;
      this.cd.detectChanges();
      this.sampleProduct = [];
      this.samplePort = [];
      this.sampleProductName = [];
      for (const item of this.data.facets) {
        if (item.name === 'productType') {
          for (const values of item.values) {
            this.sampleProduct.push({
              id: values.query.query.value,
              name: values.name,
              productType: 'Product Types',
              selected: values.selected
            });
            this.productTypes = this.sampleProduct;
          }
        }
        if (item.name === 'portName') {
          for (const values of item.values) {
           //const portUrl = values.query.url.split('=');
           this.samplePort.push({
              id: values.query.query.value,
              ports: 'Ports',
              name: values.name,
              selected: values.selected
            });

           this.ports = this.samplePort;
          }
        }
        if (item.name === 'baseProductCode') {
          for (const values of item.values) {
            this.sampleProductName.push({
              id: values.query.query.value,
              product: 'Products',
              name: values.name,
              selected: values.selected
            });
            this.productsList = this.sampleProductName;
          }
        }

      }
    });
  }
  clearAllFilter(): any {
    this.showClear = false;
    this.selectedPort = null;
    this.selectedProductType = null;
    this.selectedProduct = null;
    this.isPortNull = true;
    this.isTypeNull = true;
    this.isProductNull = true;
    this.customProductService.getFilterInput(null);
    this.currentPage = 0;
    this.pageSize = 2;
    this.getFacetsData(null);
   // this.getProductItemByProductType(null);
   //this.getProductTypeAndproductByPort(null);
    // this.ngSelectComponent.handleClearClick();
  }

  clearFilterDataMobile(event): any {
    this.mobileCurrentSelection = null;
    this.getFacetsData(this.mobileCurrentSelection);
    this.customProductService.getFilterInput(null);
    // this.getProductItemByProductType(null);
    this.searchInput = '';

  }
  omit_special_char(event): any {
    const k = event.charCode;
    return this.isValidLetter(k);
  }

  isValidLetter(k): any {
    // return ( (k >= 48 && k <= 57));
    return (k = 47);
  }

  // tslint:disable-next-line:typedef
  ngOnDestroy() {
    this.customProductService.filterValue = null;
    this.customProductService.getFilterInput(null);
  }
  // tslint:disable-next-line:typedef
  filtersidebar() {
    // this.value = document.querySelector('sidebar').width = '295px';
    this.sidebar = false;
  }
  // tslint:disable-next-line:typedef
  closebar() {
    this.sidebar = true;
  }

  submitForm(): any {
    this.closebar();
    this.length = this.portlength + this.productlength + this.producttypelength;
    if (this.length === 0){
      this.selectedProduct = null;
      this.selectedProductType = null;
      this.selectedPort = null;
    }
  //  this.filteredItemChange();
    this.customProductService.getFilterInput(this.mobileCurrentSelection);
  }
  getPortFacets(data): any {
    this.searchInput = null;
    this.getFacetsData(data.id);
    this.customProductService.filterValue = data.id;
    this.customProductService.getFilterInput(data.id);
  }
  getTypeFacets(data): any {
    this.searchInput = null;
    this.getFacetsData(data.id);
    this.customProductService.filterValue = data.id;
    this.customProductService.getFilterInput(data.id);
  }
  getProductsFacet(data): any {
    this.searchInput = null;
    this.getFacetsData(data.id);
    this.customProductService.filterValue = data.id;
    this.customProductService.getFilterInput(data.id);
    //this.myselect.close();
  }
  getFacetsMobile(data): any {
    this.searchInput = null;
    this.getFacetsData(data.id);
    this.mobileCurrentSelection =  data.id;
    this.customProductService.filterValue = data.id;
    this.customProductService.getFilterInput(data.id);
  }

  getFacetsData(query): any {
    this.customProductService.getProducts(this.currentPage, this.pageSize, 'relevance', query).subscribe(data => {
      this.data = data;
      this.customProductService.setConfirmtxt(data.confirmMessage);
      this.showClear = false;
      this.cd.detectChanges();
      this.sampleProduct = [];
      this.samplePort = [];
      this.sampleProductName = [];
      this.selectedProductType = [];
      this.selectedProduct = [];
      this.selectedPort = [];
      this.productTypes = [];
      this.productsList = [];
      this.portlength = 0;
      this.productlength = 0;
      this.producttypelength = 0;
      for (const item of this.data.facets) {
        if (item.name === 'portName') {
          for (const values of item.values) {
           //const portUrl = values.query.url.split('=');
           if (values.selected){
            this.selectedPort.push(values.query.query.value);
            this.showClear = true;
            this.portlength ++;
          }
           this.samplePort.push({
              id: values.query.query.value,
              ports: 'Ports',
              name: values.name,
              selected: values.selected
            });
           this.ports = this.samplePort;
          }
        }
        if (item.name === 'productType') {
          for (const values of item.values) {
            if (values.selected){
              this.selectedProductType.push(values.query.query.value);
              this.showClear = true;
              this.productlength ++;
            }
            this.sampleProduct.push({
              id: values.query.query.value,
              name: values.name,
              productType: 'Product Types',
              selected: values.selected
            });
            this.productTypes = this.sampleProduct;
          }
        }
        if (item.name === 'baseProductCode') {
          for (const values of item.values) {
            if (values.selected){
              this.selectedProduct.push(values.query.query.value);
              this.showClear = true;
              this.producttypelength ++;
            }
            this.sampleProductName.push({
              id: values.query.query.value,
              product: 'Products',
              name: values.name,
              selected: values.selected
            });
            this.productsList = this.sampleProductName;
          }
        }
        this.length = this.portlength + this.productlength + this.producttypelength;
      }
    });
  }
}
